import { Component, HostBinding, OnInit, ViewChild } from '@angular/core';
import { ProjectService } from '../project.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Project, ProjectFeed } from '../../models/project';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { CreateProjectModal } from '../create-projekt-modal/create-project-modal';
import { ProjectDetailInstance } from './project-detail.instance';
import { Title } from '@angular/platform-browser';
import { AlertService } from '../../core/alert.service';
import { ModalService } from '../../core/modal.service';

@Component({
  templateUrl: './project-detail.component.html',
  providers: [ProjectDetailInstance]
})

export class ProjectDetailComponent implements OnInit {
  @ViewChild('p') public popover: NgbPopover;
  @HostBinding('class') className = 'u-main-container';

  clientProjects: Project[];
  isMoving: boolean = false;
  moveProjectSelection: Project;

  constructor(private projectService: ProjectService,
              private titleService: Title,
              private route: ActivatedRoute,
              private instance: ProjectDetailInstance,
              private alert: AlertService,
              private router: Router,
              private modal: ModalService) {

  }

  ngOnInit() {
    this.instance.$project.subscribe(project => {
      if (project) {
        this.titleService.setTitle(this.instance.project.name);
      }
    });

    this.route.params
      .subscribe((params: Params) => {
        this.instance.init(+params['id']);
      });
  }

  onSlugChange(slug: string) {
    this.project.slug = slug;
  }

  onNameChange(slug: string) {
    this.project.name = slug;
  }

  onFeedAdded(feed: ProjectFeed) {
    this.project.feed = feed;
  }

  onFeedDeleted() {
    this.project.feed = null;
  }

  showEditModal() {
    const modalRef = this.modal.open(CreateProjectModal);

    modalRef.componentInstance.initExisting(this.project);
    modalRef.result.then((project) => {
      this.instance.reload();
    }, (reason) => {

    }).catch(() => {
    });
  }

  sync() {
    this.projectService.sync(this.project).subscribe(() => {
    });
  }

  deleteProject() {
    if (!confirm('Ta bort projektet?')) {
      return;
    }

    this.projectService.destroy(this.project)
      .subscribe(() => {
        this.alert.success('Project borttaget');
        this.router.navigate(['/projects']);
      });
  }

  onMoveProjectSelected(project: Project) {
    this.moveProjectSelection = project;
  }

  moveProject() {
    /*this.projectService.move(this.project, this.moveProjectSelection).subscribe((project) => {
     this.project = project;
     })*/
  }

  showEdit() {

  }

  showMove() {
    this.projectService.getProjectTreeForClient(this.project.client.id).subscribe(tree => {
      this.isMoving = true;
      this.clientProjects = tree;
    });
  }

  get project() {
    return this.instance.project;
  }

  get error() {
    return this.instance.error;
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/detail/project-detail.component.ts